<template>
  <div class="hero-title-box">
    <!-- 第一行：Pioneering the -->
    <div class="text-line first-line">
      <span
        v-for="(char, index) in firstLineText"
        :key="`first-${index}`"
        class="char"
        :class="{ 'space-char': char === ' ' }"
      >
        {{ char === ' ' ? '\u00A0' : char }}
      </span>
      <span v-if="showFirstLineCursor" class="cursor">|</span>
    </div>

    <!-- 第二行：Data Intelligence Era -->
    <div class="text-line second-line">
      <!-- Data Intelligence 部分（在Era的E前面出现） -->
      <span v-if="showDataIntelligence" class="data-intelligence-text">
        <span
          v-for="(char, index) in dataIntelligenceText"
          :key="`data-${index}`"
          class="char"
          :class="{ 'space-char': char === ' ' }"
        >
          {{ char === ' ' ? '\u00A0' : char }}
        </span>
      </span>

      <!-- Era 部分 -->
      <span
        v-for="(char, index) in secondLineText"
        :key="`second-${index}`"
        class="char"
        :class="{ 'space-char': char === ' ' }"
      >
        {{ char === ' ' ? '\u00A0' : char }}
      </span>
      <span v-if="showSecondLineCursor" class="cursor">|</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      // 第一行文字
      firstLineFull: 'Pioneering the',
      firstLineText: '',
      firstLineIndex: 0,
      showFirstLineCursor: true,

      // 第二行文字
      secondLineFull: 'Era',
      secondLineText: '',
      secondLineIndex: 0,
      showSecondLineCursor: false,

      // Data Intelligence 文字
      dataIntelligenceFull: 'Data Intelligence',
      dataIntelligenceText: '',
      dataIntelligenceIndex: 0,

      // 控制显示
      showDataIntelligence: false,

      // 打字速度
      typeSpeed: 100,

      // 状态控制
      currentPhase: 'first-line', // first-line, second-line, data-intelligence
    };
  },
  mounted() {
    // 延迟开始打字效果
    // 先让光标闪两下再开始打字（基于 CSS 动画迭代事件，精确计数两次）
    this.$nextTick(() => {
      const cursorEl = this.$el.querySelector('.cursor');
      if (cursorEl) {
        let blinkIterations = 0;
        const handleIter = () => {
          blinkIterations += 1;
          if (blinkIterations >= 2) {
            cursorEl.removeEventListener('animationiteration', handleIter);
            this.startTypewriter();
          }
        };
        cursorEl.addEventListener('animationiteration', handleIter);
      } else {
        this.startTypewriter();
      }
    });
  },
  methods: {
    startTypewriter() {
      this.typeFirstLine();
    },

    // 第一行打字效果
    typeFirstLine() {
      if (this.firstLineIndex < this.firstLineFull.length) {
        this.firstLineText += this.firstLineFull[this.firstLineIndex];
        this.firstLineIndex++;

        setTimeout(() => {
          this.typeFirstLine();
        }, this.typeSpeed);
      } else {
        // 第一行完成，隐藏光标，开始第二行
        this.showFirstLineCursor = false;
        setTimeout(() => {
          this.currentPhase = 'second-line';
          this.showSecondLineCursor = true;
          this.typeSecondLine();
        }, 100);
      }
    },

    // 第二行打字效果
    typeSecondLine() {
      if (this.secondLineIndex < this.secondLineFull.length) {
        this.secondLineText += this.secondLineFull[this.secondLineIndex];
        this.secondLineIndex++;

        setTimeout(() => {
          this.typeSecondLine();
        }, this.typeSpeed);
      } else {
        // 第二行完成，隐藏光标
        this.showSecondLineCursor = false;

        // 当"Era"的"a"打完后，开始"Data Intelligence"的打字机效果
        setTimeout(() => {
          this.showDataIntelligence = true;
          this.typeDataIntelligence();
        }, 100);
      }
    },

    // Data Intelligence 打字机效果
    typeDataIntelligence() {
      if (this.dataIntelligenceIndex < this.dataIntelligenceFull.length) {
        this.dataIntelligenceText +=
          this.dataIntelligenceFull[this.dataIntelligenceIndex];
        this.dataIntelligenceIndex++;

        setTimeout(() => {
          this.typeDataIntelligence();
        }, this.typeSpeed);
      } else {
        // Data Intelligence 打字完成
        console.log('Data Intelligence 打字完成!');
        this.$emit('animationComplete');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.hero-title-box {
  position: relative;
  width: 780px;
  //   display: flex;
  align-items: center;
  overflow: visible; // 确保内容不被裁剪
}

.text-line {
  display: flex;
  align-items: center;
  font-size: 80px;
  font-weight: 600;
  color: #222226;
  font-family: 'MiSans-Demibold';

  justify-content: center;
  line-height: 110px; // 增加行高，确保字母g的下伸部分完全显示
  margin: 10px 0;
  white-space: nowrap;
  overflow: visible; // 确保内容不被裁剪
}
.first-line {
  //   color: #2c3e50;
}

.second-line {
  position: relative;
}
.char {
  //   margin-right: 2px;
}

// 空格字符的特殊样式
.space-char {
  white-space: pre;
  min-width: 0em; // 确保空格有最小宽度
}

.data-intelligence-text {
  margin-right: 25px;
  overflow: visible; // 确保渐变文本不被裁剪
  line-height: inherit; // 继承父元素的行高
}

.data-intelligence-text {
  background: linear-gradient(35.342353434743124deg, #005fe6 0%, #2eb6d8 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.cursor {
  color: #005fe6;
  font-family: auto;
  width: 4px;
  animation: blink 0.2s infinite;
  // margin-left: 4px;
  position: relative;
}

@keyframes blink {
  0%,
  50% {
    opacity: 1;
  }
  51%,
  100% {
    opacity: 0;
  }
}
</style>
